import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { API_BASE_URL } from '../../utils/config.js' 
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import ErrorAlert from '../../components/common/ErrorAlert'
import Table from '../../components/tables/TableFilter'
import Button from '../../components/common/Button'
import Modal from '../../components/modals/Modal'
import ModalConfirmacion from '../../components/modals/ModalConfirmacion'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import { FaFileExcel  } from "react-icons/fa"

const Profesionales = () => {
  const [datos, setDatos] = useState([])
  const [datosEspecialidades, setDatosEspecialidades] = useState([])
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
  // campos 
  const [idProfesional, setIdProfesional] = useState("")
  const [tipoPersona, setTipoPersona] = useState("0")
  const [documento, setDocumento] = useState("")
  const [nombres, setNombres] = useState("")
  const [especialidad, setEspecialidad] = useState("")
  const [domicilio, setDomicilio] = useState("")
  const [telefono, setTelefono] = useState("")
  const [email, setEmail] = useState("")
  const [filtroEstado, setFiltroEstado] = useState('1') // Por defecto "1" (ACTIVO)
  // modales 
  const [mostrarModal, setMostrarModal] = useState(false)
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
  // notificaciones y cargas 
  const [cargando, setCargando] = useState(true)
  const [cargandoReniec, setCargandoReniec] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  // eliminar un profesional 
  const [selectedId, setSelectedId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //datos para la tabla
  const columnas = [
    { titulo: 'Tipo documento', campo: 'tipo_persona' },
    { titulo: 'Documento', campo: 'documento_profesional' },
    { titulo: 'Nombres', campo: 'nombres_profesional' },
    { titulo: 'Especialidad', campo: 'especialidad' },
    { titulo: 'Dirección', campo: 'domicilio_profesional' },
    { titulo: 'Telefono', campo: 'telefono_profesional' },
    { titulo: 'Email', campo: 'email_profesional' },
    { titulo: 'Estado', campo: 'estado' },
  ]

  // Carga inicial de los Profesionales
  useEffect(() => { obtenerProfesionales() }, [filtroEstado])
  useEffect(() => { obtenerEspecialidades() }, [])

  // Funcion para buscar en la BD de RENIEC el DNI
  const obtenerPersona = async (dni) => {
    setDocumento(dni)
    setNombres('')
    if (dni.length === 8 && tipoPersona === '0') {
      setCargandoReniec(true)
      const respuesta = await consumirApi('GET', `reniec/${dni}`)
      const datos = respuesta.data[0]
      if (datos) {
        setNombres(datos.nombre + ' ' + datos.ape_pat + ' ' + datos.ape_mat)
      }
      setCargandoReniec(false)
    }
  }

  // Funcion para obtener los Profesionales
  const obtenerProfesionales = async () => {
    const respuesta = await consumirApi('GET', `profesional/${idEmpresa}/${filtroEstado}`)
    setDatos(respuesta.success ? respuesta.data : respuesta.error)
    setCargando(false)
  }

    // Función para traer los tipos de terreno
    const obtenerEspecialidades = async () => {
      const respuesta = await consumirApi('GET', `maestros/especialidad`)
      setDatosEspecialidades(respuesta.success ? respuesta.data : respuesta.error)
      setCargando(false)
  }

  // Funcion para registrar un nuevo profesional
  const registrarProfesional = (async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    agregarDatosEmpresaUsuario(formData)
    setIsSubmitting(true)
    const respuesta = await consumirApi('POST', `profesional`, formData)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "registro", mensaje: "Profesional registrado correctamente" })
      limpiarCampos()
      obtenerProfesionales()
    }
    else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  })

  // funcion para abrir el modal para editar profesional
  const abrirModalEditar =  (data) => {
    setIdProfesional(data.id)
    setDocumento(data.documento_profesional)
    setNombres(data.nombres_profesional)
    setEspecialidad(data.especialidad_id)
    setDomicilio(data.domicilio_profesional)
    setTelefono(data.telefono_profesional)
    setEmail(data.email_profesional)
    setMostrarModalEditar(true)
  }

  // Edición profesional
  const enviarEdicionProfesional = async (e) => {
    e.preventDefault()
    const data = { documento_profesional: documento, nombres_profesional: nombres, especialidad_id: especialidad,domicilio_profesional: domicilio, telefono_profesional: telefono, email_profesional:email }
    setIsSubmitting(true)
    const respuesta = await consumirApi('PATCH', `profesional/${idProfesional}`, data)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Profesional actualizado correctamente" })
      limpiarCampos()
      obtenerProfesionales()
    } else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  }

  // Manejar selección de checkbox
  const seleccionProfesional = (data) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
  }

  const eliminarProfesional = async () => {
    const respuesta = await consumirApi('DELETE', `profesional/${selectedId}`)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Profesional eliminado correctamente" })
      limpiarCampos()
      obtenerProfesionales()
    } else {
      setError(respuesta.error)
    }
  }

   // funcion para abrir el modal para editar TipoTerreno
   const actualizarEstadoProfesional = async () => {
        const respuesta = await consumirApi('PATCH', `profesional/${selectedId}/estado`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Estado de profesional actualizado correctamente" })
            limpiarCampos()
            obtenerProfesionales()
        } else {
            setError(respuesta.error)
        }
    }

    const manejarCambioFiltro = (e) => {
      setFiltroEstado(e.target.value)
      setSelectedId(null)
    }

  const limpiarCampos = () => {
    setMostrarModal(false)
    setMostrarModalEditar(false)
    setMostrarModalEliminar(false)
    setError('')
    setSelectedId(null)
    setDocumento('')
    setNombres('')
    setDomicilio('')
    setTelefono('')
    setEmail('')
    setTimeout(() => {
      setIsSubmitting(false)
    }, 300)
  }

  return (
    <div className='w-full min-h-[calc(100vh-50px)]'>
      <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
      <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
      <Button className="mx-3 mt-2" texto=" &#x21bb;" type="update" disabled={!selectedId} onClick={actualizarEstadoProfesional} />
      <select className="border rounded-md p-1 mt-2" value={filtroEstado} onChange={manejarCambioFiltro} >
          <option value="1">ACTIVO</option>
          <option value="0">INHABILITADO</option>
          <option value="all">TODOS</option>
        </select>
      <FaFileExcel size={30} color="green" className="ml-3 mt-0 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/profesionales/${idEmpresa}`, "_blank")} />

      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : (
        datos.length === 0 ? (
          <div className="ml-5 mt-2">No se encontraron Profesionales</div>
        ) : (
          <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
            mostrarChecks={true}
            seleccionFila={seleccionProfesional} // Manejar el ID seleccionado
            selectedId={selectedId} // Manejar el ID seleccionado
          />
        )
      )}

      {/* Modal Registrar nuevo profesional*/}
      <Modal isOpen={mostrarModal} title="Registrar nuevo profesional" onClose={limpiarCampos} >
        <Form onSubmit={registrarProfesional} isSubmitting={isSubmitting}>
          <Input name="documento_profesional" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_profesional" value={nombres} label="Nombres" onChange={setNombres} />
          <Input 
              name="especialidad_id" 
              value={especialidad} 
              label="Especialidad" 
              type="select" 
              onChange={setEspecialidad}
              options={datosEspecialidades.map((e) => ({
                value: e.id,
                label: e.especialidad,
              }))}
            />
          <Input name="domicilio_profesional" value={domicilio} label="Dirección" onChange={setDomicilio} />
          <Input name="telefono_profesional" value={telefono} label="Telefono" onChange={setTelefono} />
          <Input name="email_profesional" value={email} label="Email" onChange={setEmail} />
          
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal Actuazliar profesional*/}
      <Modal isOpen={mostrarModalEditar} title="Actualizar Profesional" onClose={limpiarCampos} >
        <Form onSubmit={enviarEdicionProfesional}  isSubmitting={isSubmitting} type='update'>
          <Input name="documento_profesional" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_profesional" value={nombres} label="Nombres" onChange={setNombres} />
          <Input 
              name="especialidad_id" 
              value={especialidad} 
              label="Especialidad" 
              type="select" 
              onChange={setEspecialidad}
              options={datosEspecialidades.map((e) => ({
                value: e.id,
                label: e.especialidad,
              }))}
            />
          <Input name="domicilio" value={domicilio} label="Dirección" onChange={setDomicilio} />
          <Input name="telefono" value={telefono} label="Telefono" onChange={setTelefono} />
          <Input name="email_profesional" value={email} label="Email" onChange={setEmail} />
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal de confirmación para eliminar un profesional*/}
      <ModalConfirmacion
        isOpen={mostrarModalEliminar}
        onClose={limpiarCampos}
        onConfirm={eliminarProfesional}
        mensaje="¿Estás seguro de que deseas eliminar profesional?"
      >
        {error && <ErrorAlert message={error} />}
      </ModalConfirmacion>
    </div>
  )
}

export default Profesionales
